import { useState } from 'react';
import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { cardPad } from '../../lib/ui';

export default function Batch() {
  const { go, L } = useApp();
  const [sent, setSent] = useState(false);

  const fleetGroups = [
    { cls: 'Class 1 — Sedans & SUVs', vehicles: [
      { plate: 'กท-1234', desc: 'Toyota Camry 2.5G', sum: '$1,250,000' },
      { plate: 'กท-1290', desc: 'Honda CR-V EL', sum: '$1,480,000' },
      { plate: 'กข-4471', desc: 'Toyota Fortuner', sum: '$1,890,000' },
    ] },
    { cls: 'Class 2 & 3 — Pickups & Vans', vehicles: [
      { plate: 'บบ-7781', desc: 'Isuzu D-Max', sum: '$980,000' },
      { plate: 'บว-3320', desc: 'Toyota Hiace', sum: '$1,120,000' },
    ] },
  ];
  const batchInsurers = [
    { name: 'Apex Insurance Co.', meta: 'SUP-001 · Tier 1', reg: 'Registered' },
    { name: 'Summit Underwriters', meta: 'SUP-003 · Tier 1', reg: 'Registered' },
    { name: 'Pacific Insurance Co.', meta: 'SUP-006 · Tier 2', reg: 'Registered' },
    { name: 'Northgate Insurance', meta: 'Pending review', reg: 'Invited' },
  ];

  if (sent) {
    return (
      <div style={{ ...cardPad(40), maxWidth: 560, margin: '0 auto', textAlign: 'center' }}>
        <div style={{ width: 56, height: 56, borderRadius: 999, background: 'var(--color-success-bg)', color: 'var(--color-success)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 24 }}><Icon name="send" /></div>
        <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 10 }}>{L('Batch RFQ Sent', 'ส่ง RFQ แบบชุดแล้ว')}</div>
        <div style={{ fontSize: 13, color: 'var(--color-fg-3)', marginBottom: 6 }}><b style={{ fontFamily: 'var(--font-mono)' }}>RFQ-2026-006</b> {L('sent to 3 insurers for 8 fleet vehicles · Total sum insured', 'ส่งให้ผู้รับประกันภัย 3 ราย สำหรับยานพาหนะ 8 คัน · ทุนประกันรวม')} <b style={{ fontFamily: 'var(--font-mono)' }}>$10.17M</b>.</div>
        <div style={{ fontSize: 13, color: 'var(--color-fg-3)', marginBottom: 22 }}>{L('Bid deadline:', 'กำหนดส่งข้อเสนอ:')} <b>2026-07-15</b>{L('. Insurers are notified via email and portal link; their quotes stay sealed until the deadline.', '. ผู้รับประกันภัยจะได้รับแจ้งทางอีเมลและลิงก์พอร์ทัล ใบเสนอราคาจะถูกปิดผนึกจนกว่าจะถึงกำหนด')}</div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button onClick={() => go('inscompare')} className="hv-primary" style={{ padding: '10px 20px', background: 'var(--color-primary)', color: '#fff', borderRadius: 'var(--radius-md)', fontWeight: 600, fontSize: 14 }}>{L('View Insurance Comparison', 'ดูการเปรียบเทียบประกันภัย')}</button>
          <button onClick={() => setSent(false)} className="hv-ink" style={{ padding: '10px 20px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-md)', fontWeight: 600, fontSize: 14, background: 'var(--color-white)' }}>{L('Back to Batch RFQ', 'กลับไปยัง RFQ แบบชุด')}</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1.3fr 1fr', gap: 16, alignItems: 'start' }}>
      <div style={cardPad(20)}>
        <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('Select Fleet Vehicles', 'เลือกยานพาหนะ')}</div>
        {fleetGroups.map((g) => (
          <div key={g.cls} style={{ marginBottom: 14 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, fontWeight: 700, color: 'var(--color-fg-3)', textTransform: 'uppercase', marginBottom: 8, cursor: 'pointer' }}>
              <input type="checkbox" defaultChecked />{L(g.cls, g.cls === 'Class 1 — Sedans & SUVs' ? 'ชั้น 1 — เก๋งและ SUV' : 'ชั้น 2 และ 3 — กระบะและแวน')}
            </label>
            {g.vehicles.map((v) => (
              <label key={v.plate} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-sm)', marginBottom: 6, cursor: 'pointer' }}>
                <input type="checkbox" defaultChecked />
                <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, fontSize: 12, flex: 'none' }}>{v.plate}</span>
                <span style={{ flex: 1, fontSize: 12, color: 'var(--color-fg-2)' }}>{v.desc}</span>
                <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, fontSize: 12 }}>{v.sum}</span>
              </label>
            ))}
          </div>
        ))}
        <div style={{ fontSize: 12, color: 'var(--color-fg-3)', paddingTop: 8, borderTop: '1px solid var(--color-border)' }}>{L('8 of 8 vehicles selected · Total Sum Insured:', 'เลือกยานพาหนะแล้ว 8 จาก 8 คัน · ทุนประกันรวม:')} $10.17M</div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div style={cardPad(20)}>
          <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('Select Insurers to Invite', 'เลือกผู้รับประกันภัยที่จะเชิญ')}</div>
          {batchInsurers.map((ins) => (
            <label key={ins.name} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-sm)', marginBottom: 8, cursor: 'pointer' }}>
              <input type="checkbox" defaultChecked />
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{ins.name}</div>
                <div style={{ fontSize: 11, color: 'var(--color-fg-3)' }}>{L(ins.meta, ins.meta === 'Pending review' ? 'รอตรวจสอบ' : ins.meta)}</div>
              </div>
              <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: 'var(--color-success-bg)', color: 'var(--color-success)' }}>{L(ins.reg, ins.reg === 'Registered' ? 'ลงทะเบียนแล้ว' : 'เชิญแล้ว')}</span>
            </label>
          ))}
          <label style={{ display: 'block', fontSize: 12, fontWeight: 600, margin: '10px 0 6px' }}>{L('Bid Deadline', 'กำหนดส่งข้อเสนอ')}</label>
          <input type="date" defaultValue="2026-07-15" style={{ width: '100%', padding: '9px 12px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', background: 'var(--color-white)' }} />
        </div>
        <button onClick={() => setSent(true)} className="hv-primary" style={{ padding: '12px 20px', background: 'var(--color-primary)', color: '#fff', borderRadius: 'var(--radius-md)', fontWeight: 600, fontSize: 14 }}>{L('Send Batch RFQ (8 vehicles · 3 insurers)', 'ส่ง RFQ แบบชุด (ยานพาหนะ 8 คัน · ผู้รับประกันภัย 3 ราย)')}</button>
      </div>
    </div>
  );
}
